














































































import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { FormatReferenceTreeEditDialogModel } from ".";
import { Directory } from "../../../../../domain/drawing";
import { FormatReference } from "../../../../../domain/format";
import { IRectangle } from "../../../../../domain/system";
import FormatReferenceTreeAddFolderDialog from "./FormatReferenceTreeAddFolderDialog.vue";
import FormatReferenceTreeAddFormatTreeDialog from "./FormatReferenceTreeAddFormatTreeDialog.vue";
import { IEditTreeSource, ITreeSource } from "../sources";
import FormatReferenceTreeEditor from "./FormatReferenceTreeEditor.vue";
import { DialogMixin, PdfStyleDrawableMixin } from "../../../../system/mixins";
import { IGeometryManageable } from "../../../../system/utilities";
import Separator from "../../../../system/Separator.vue";
import PdfViewer from "../../../../system/viewers/PdfViewer.vue";

interface IFormatReferenceTreeEditDialogGeometry extends IRectangle {
  formatReferenceTreeEditDialog?: {
    selector: {
      width: number;
    };
  };
}

@Component({
  components: {
    folderDialog: FormatReferenceTreeAddFolderDialog,
    formatTreeDialog: FormatReferenceTreeAddFormatTreeDialog,
    FormatReferenceTreeEditor,
    Separator,
    PdfViewer,
  }
})
export default class FormatReferenceTreeEditDialog extends Mixins(DialogMixin, PdfStyleDrawableMixin) implements IGeometryManageable<IFormatReferenceTreeEditDialogGeometry> {
  static instanceOfSource(instance: any): instance is FormatReferenceTreeEditDialog {
    return (instance
      && instance.show !== undefined);
  }

  data(): any {
    return {
      result: false,
      editDialogModel: new FormatReferenceTreeEditDialogModel<FormatReference>(),
      selectorWidth: 500,
      shouldIgnoreChained: false,
      shouldAddRootFolder: false,
    };
  }
  result: boolean;
  editDialogModel: FormatReferenceTreeEditDialogModel<FormatReference>;
  selectorWidth: number;
  shouldIgnoreChained: boolean;
  shouldAddRootFolder: boolean;

  @Prop()
  treeSource: ITreeSource<FormatReference> & IEditTreeSource<FormatReference>;

  get isLoaded(): boolean {
    return !!this.editingDirectories;
  }

  get editingDirectories(): Directory<string, FormatReference>[] {
    return this.editDialogModel.editingDirectories;
  }

  set editingDirectories(value: Directory<string, FormatReference>[]) {
    this.editDialogModel.editingDirectories = value;
  }

  get selectedDirectory(): Directory<string, FormatReference> {
    return this.editDialogModel.selectedDirectory;
  }

  get selectedFormat(): FormatReference {
    return this.editDialogModel.selectedFormat;
  }

  get editFolderText(): string {
    return this.editDialogModel.editFolderText;
  }

  set editFolderText(value: string) {
    this.editDialogModel.editFolderText = value;
  }

  get editFormatText(): string {
    return this.editDialogModel.editFormatText;
  }

  set editFormatText(value: string) {
    this.editDialogModel.editFormatText = value;
  }

  get addFolderText(): string {
    return this.editDialogModel.addFolderText;
  }

  set addFolderText(value: string) {
    this.editDialogModel.addFolderText = value;
  }

  get deleteFolderFlag(): boolean {
    return this.editDialogModel.deleteFolderFlag;
  }

  set deleteFolderFlag(value: boolean) {
    this.editDialogModel.deleteFolderFlag = value;
  }

  get deleteFormatFlag(): boolean {
    return this.editDialogModel.deleteFormatFlag;
  }

  set deleteFormatFlag(value: boolean) {
    this.editDialogModel.deleteFormatFlag = value;
  }

  get updateCompletedDirectoriesFlag(): boolean {
    return this.editDialogModel.updateCompletedDirectoriesFlag;
  }

  set updateCompletedDirectoriesFlag(value: boolean) {
    this.editDialogModel.updateCompletedDirectoriesFlag = value;
  }

  get completedDirectories(): Directory<string, FormatReference>[] {
    return this.editDialogModel.completedDirectories;
  }

  get isSelectedDirectory(): boolean {
    return this.selectedDirectory instanceof Directory;
  }

  get isSelectedFormatReference(): boolean {
    return this.selectedFormat instanceof FormatReference;
  }

  get selectedPreviewSource(): string {
    return (this.isSelectedFormatReference && this.selectedFormat.previewSource)
      ? this.selectedFormat.previewSource.source
      : "";
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  @Watch("selectedDirectory")
  onSelectedDirectoryChanged(newValue: Directory<string, FormatReference>, oldValue: Directory<string, FormatReference>): void {
    this.editFolderText = newValue
      ? newValue.name
      : "";
  }

  @Watch("selectedFormat")
  onSelectedFormatChanged(newValue: FormatReference, oldValue: FormatReference): void {
    this.editFormatText = newValue
      ? newValue.name
      : "";
  }

  created(): void {
    this.$registerGeometryManager(this);
  }

  destroyed(): void {
    this.$unregisterGeometryManager(this);
  }

  getGeometryNames(isWindowRectangleHandleable: boolean): string[] {
    return [
      "ペイン幅",
    ];
  }

  storeGeomerty(source: IFormatReferenceTreeEditDialogGeometry, isWindowRectangleHandleable: boolean): void {
    source.formatReferenceTreeEditDialog = {
      selector: {
        width: this.selectorWidth,
      },
    };
  }

  restoreGeomerty(source: IFormatReferenceTreeEditDialogGeometry, isWindowRectangleHandleable: boolean): void {
    if (!source.formatReferenceTreeEditDialog) {
      return;
    }
    this.selectorWidth = source.formatReferenceTreeEditDialog.selector.width;
  }

  async show(shouldIgnoreChained: boolean): Promise<void> {
    return this.showModal(async () => {
      this.result = false;
      this.shouldIgnoreChained = shouldIgnoreChained;
      this.editDialogModel.clear();
      this.editingDirectories = await this.getNewClonedTree();
      await this.waitHidden();
      this.editingDirectories = null; // 次回表示を滑らかにするために削除しておく
      // TODO: キャンセル時の挙動は修正したほうがよさそうに見える
      if (!this.result) {
        throw new Error("編集結果がありません。");
      }
    });
  }

  /**
   * Object.freezeされているので、編集できるようにclone()して返却している
   */
  private async getNewClonedTree(): Promise<Directory<string, FormatReference>[]> {
    const directories = await this.treeSource.getTree();
    return Enumerable.from(directories)
      .select(r => r.clone())
      .toArray();
  }

  async showAddRootFolder(): Promise<void> {
    try {
      this.addFolderText = "";
      // editDialogModel.addFolderTextの値が変わったタイミングで選択中のフォルダ下に新規フォルダが作成される。
      // フォルダ追加では選択状態維持したままなので、フラグで先頭フォルダを作成するタイミングを制御
      this.shouldAddRootFolder = true;
      const dialog = this.$refs.folderDialog;
      if (FormatReferenceTreeAddFolderDialog.instanceOfSource(dialog)) {
        await dialog.show();
      }
    } catch (e) {
      console.warn(e);
    } finally {
      await this.$nextTick();
      this.shouldAddRootFolder = false;
    }
  }

  async showAddFolder(): Promise<void> {
    try {
      this.addFolderText = "";
      const dialog = this.$refs.folderDialog;
      if (FormatReferenceTreeAddFolderDialog.instanceOfSource(dialog)) {
        await dialog.show();
      }
    } catch {}
  }

  async deleteFolder(): Promise<void> {
    const isConfirmed = await this.confirmToDelete("フォルダ");
    if (!isConfirmed) { return; }
    this.deleteFolderFlag = true;
    await this.$nextTick();
    this.deleteFolderFlag = false;
  }

  async showAddFormatTree(): Promise<void> {
    try {
      const dialog = this.$refs.formatTreeDialog;
      if (FormatReferenceTreeAddFormatTreeDialog.instanceOfSource(dialog)) {
        await dialog.show(this.shouldIgnoreChained);
      }
    } catch {}
  }

  async deleteFormatTree(): Promise<void> {
    const isConfirmed = await this.confirmToDelete(this.formatNameWording);
    if (!isConfirmed) { return; }
    this.deleteFormatFlag = true;
    await this.$nextTick();
    this.deleteFormatFlag = false;
  }

  private async confirmToDelete(target: string): Promise<boolean> {
    const index = await this.$commonDialogs.confirmation.confirmDeleteCancel(
      target + "の削除",
      [target + "を削除してもよろしいですか？"]
    );
    return (index === 0);
  }

  async save(): Promise<void> {
    if (!this.isVisible) {
      return;
    }
    try {
      this.updateCompletedDirectoriesFlag = true;
      await this.$nextTick();
      this.updateCompletedDirectoriesFlag = false;
      if (!this.isVisible) {
        return;
      }
      await this.treeSource.saveEditTree(this.completedDirectories);
      this.$success("頻用" + this.formatNameWording + "編集", "保存しました。");
      this.result = true;
    } catch (e) {
      this.$error("エラー", "頻用" + this.formatNameWording + "ツリーの保存処理中にエラーが発生しました。", e);
    }
    this.isVisible = false;
  }

  cancelEdit(): void {
    this.isVisible = false;
  }
}
